import { DOCUMENT } from '@angular/common';
import { Component, HostListener, Inject, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { WINDOW } from '@cuepid/core';
import { InfluencerService } from '@cuepid/influencer/core/services/influencer.service';
import { Angulartics2GoogleTagManager } from 'angulartics2/gtm';
import { filter, mergeMap, tap } from 'rxjs/operators';
import { ReconnectAlertDialogComponent } from './shared/components/reconnect-alert-dialog/reconnect-alert-dialog.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  constructor(
    @Inject(WINDOW) private window: Window,
    @Inject(DOCUMENT) private document: Document,
    private readonly dialog: MatDialog,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly influencerService: InfluencerService,
    analytics: Angulartics2GoogleTagManager
  ) {
    analytics.startTracking();
  }

  @HostListener('window:resize')
  onViewResize() {
    this.setViewHeightProperty();
    this.setViewWidthProperty();
  }

  ngOnInit(): void {
    this.setViewHeightProperty();
    this.setViewWidthProperty();
    this.checkReconnectAlertOnLogin();
  }

  private setViewHeightProperty() {
    const displayHeight = this.window.innerHeight;
    this.document.documentElement.style.setProperty(
      '--vh-base',
      `${displayHeight / 100}px`
    );
  }

  private setViewWidthProperty() {
    let displayWidth = this.window.visualViewport.width;
    if (displayWidth > 390) {
      displayWidth = 390;
    }
    this.document.documentElement.style.setProperty(
      '--vw-base',
      `${displayWidth / 100}px`
    );
  }

  private checkReconnectAlertOnLogin(): void {
    // ログイン成功時のみチェック（URLパラメータで判定）
    this.route.queryParams
      .pipe(
        filter((params) => params['logged_in'] === '1'),
        tap(() => {
          // URLからパラメータを削除
          this.router.navigate([], {
            queryParams: {},
            replaceUrl: true,
          });
        }),
        mergeMap(() => this.influencerService.get()),
        filter(
          (user) =>
            !!(
              user.instagram_account?.need_reconnect ||
              user.tiktok_account?.need_reconnect
            )
        ),
        mergeMap((user) => {
          const ref = this.dialog.open(ReconnectAlertDialogComponent, {
            data: { influencer: user },
            disableClose: true,
            panelClass: 'no-padding-dialog',
          });
          return ref.afterClosed().pipe(
            tap((goToReconnect) => {
              if (goToReconnect) {
                this.router.navigate(['/user/profile']);
              }
            })
          );
        })
      )
      .subscribe();
  }
}
